import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import styles from "./VoiceRecording.module.scss";
import Toggle from "component/atom/forms/toggle/Toggle";
import Container from "component/atom/container/Container";
import { FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import VoiceCardsContainer from "component/molecules/voice-recording/voiceCardContainer/VoiceCardsContainer";
import Loader from "component/atom/loader/Loader";

const VoiceRecordingTemplate = forwardRef(({ id, data, isFetching }, ref) => {
  const validationSchema = Yup.object({
    readAloud: Yup.boolean().required("readAloud is Required").nullable(),
    recording: Yup.boolean().required("Recording is Required"),
    voiceId: Yup.number().required("VoiceId is Required"),
  });

  const formik = useFormik({
    initialValues: {
      readAloud: data?.data?.readAloud || false,
      recording: data?.data?.recording || false,
      voiceId: data?.data?.voiceId,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {},
  });

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      formik.submitForm();
    },
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  if (isFetching) {
    return <Loader isComponent />;
  }

  return (
    <>
      <FormikProvider value={formik} innerRef={ref}>
        <div className={styles["toggles-container"]}>
          <Toggle
            label="Recording"
            left
            name="recording"
            value={formik.values.recording}
            onChange={formik.handleChange}
            error={formik.errors.recording}
            touched={formik.touched.recording}
          />
          <Toggle
            label="Read-Loud"
            left
            name="readAloud"
            value={formik.values.readAloud}
            onChange={formik.handleChange}
            error={formik.errors.readAloud}
            touched={formik.touched.readAloud}
          />
        </div>
        <VoiceCardsContainer activeVoice={data?.data?.voiceId} />
      </FormikProvider>
    </>
  );
});

export default VoiceRecordingTemplate;
